import * as React from "react";
import { InputText, InputTextProps } from "@aksara-ui/react";
import { InputIcon, InputIconButton } from "../InputIcon";
import { IconCloseRounded, IconSearch } from "@aksara-ui/icons";
import { InputGroup } from "../InputGroup";

export interface InputSearchboxProps
  extends InputTextProps,
    Omit<React.ComponentPropsWithoutRef<"input">, "value"> {
  groupId?: string;
  groupClassName?: string;
  groupStyle?: React.CSSProperties;
  onClearButton?: React.MouseEventHandler<HTMLButtonElement>;
}

const InputSearchbox = React.forwardRef<HTMLInputElement, InputSearchboxProps>(
  (
    {
      id,
      className,
      groupId,
      groupClassName,
      groupStyle,
      errors,
      disabled,
      onChange,
      onClearButton,
      ...rest
    },
    ref
  ) => {
    const [value, setValue] = React.useState<string>("");

    const handleChange = React.useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);

        if (onChange) {
          onChange(e);
        }
      },
      [onChange]
    );

    const handleClearButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      setValue("");

      if (onClearButton) {
        onClearButton(e);
      }
    };

    return (
      <InputGroup
        id={groupId}
        className={groupClassName}
        style={groupStyle}
        width="100%"
        maxWidth={360}
      >
        <InputText
          ref={ref}
          id={id}
          className={className}
          errors={errors}
          disabled={disabled}
          width="100%"
          value={value}
          onChange={handleChange}
          style={{ borderRadius: 9999, paddingLeft: 36, paddingRight: 36 }}
          {...rest}
        />
        <InputIcon
          icon={IconSearch}
          iconPosition="left"
          iconText="Username"
          disabled={disabled}
        />
        {value.length > 0 && (
          <InputIconButton
            type="button"
            icon={IconCloseRounded}
            iconPosition="right"
            iconText="Clear"
            disabled={disabled}
            onClick={handleClearButtonClick}
          />
        )}
      </InputGroup>
    );
  }
);

InputSearchbox.displayName = "InputSearchbox";

export default InputSearchbox;
